// Meta Pixel utility for tracking events
const PIXEL_ID = '1596283211482504'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Bootstrap the fbq queue (mirrors the official Meta Pixel snippet, but
  // without the brittle "insert before first <script>" trick which fails
  // when the DOM has no script tags yet).
  const w = window as any
  if (!w.fbq) {
    const n: any = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
    }
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    w.fbq = n
  }

  // Inject the loader script directly into <head>
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Fire init + first PageView
  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')

  // noscript fallback for users with JS disabled
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

export function trackAddToCart(data?: {
  value?: number
  currency?: string
  content_name?: string
}) {
  if (typeof window === 'undefined' || !(window as any).fbq) return
  ;(window as any).fbq('track', 'AddToCart', {
    value: data?.value ?? 89,
    currency: data?.currency ?? 'MXN',
    content_name: data?.content_name ?? 'El Manual de las Migajas',
  })
}
